<bspk-form-field [controlId]="controlId()"
                 [errorMessage]="errorMessage() || errorState()"
                 [helperText]="helperText()"
                 [label]="label()"
                 [required]="required()">
  <bspk-text-input #trigger="cdkOverlayOrigin"
                   cdkOverlayOrigin
                   placeholder="--:-- PM"
                   [controlId]="controlId()"
                   [disabled]="disabled()"
                   [invalid]="invalid() || !!errorState()"
                   [label]="label()"
                   [readOnly]="readOnly()"
                   [size]="size()"
                   [value]="inputValue()"
                   (blur)="handleBlur()"
                   (valueChange)="handleInput($event)">
    <button aria-label="Open timepicker"
            bspk-button
            data-trailing
            hideLabel
            icon="Schedule"
            style="margin-right: -8px; align-self: center" variant="tertiary"
            [disabled]="disabled() || readOnly()"
            (click)="open()">
    </button>
  </bspk-text-input>
</bspk-form-field>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayHasBackdrop
  [cdkConnectedOverlayOpen]="isOpen() && !disabled() && !readOnly()"
  [cdkConnectedOverlayOrigin]="trigger"
  (backdropClick)="close()"
>
  <bspk-timepicker-container [hour]="hours12()"
                             [minute]="value().minutes"
                             [period]="period()"
                             (hourChange)="setHours($event)"
                             (minuteChange)="setMinutes($event)"
                             (periodChange)="setPeriod($event)"
  />
</ng-template>
